import {autoRegister} from "../../container";
import type {Lifetime} from "../../common/lifetime";
import {GLOBAL} from "../../common/globals";
import {elementFrom} from "../../common/utils/html";
import type {Nullable} from "../../bootstrap/common/types";

@autoRegister()
export class PageFeatures {

    public constructor(
        private body: HTMLElement = GLOBAL.bodyElement()
    ) {
        this.pageFeaturesElement();
    }

    public pageFeaturesElement(): Element {
        // pageFeatures element is written by cms page templates
        return this.body.querySelector("#pagefeatures")
            ?? this.body.appendChild(elementFrom("<div id='pagefeatures'></div>"));
    }

    public dropAll(): void {
        this.pageFeaturesElement().remove();
    }

    public insert<T extends Element>(element: T, lifetime?: Lifetime): T {
        const insertionPoint = this.pageFeaturesElement();
        const childElement = insertionPoint.appendChild(element);
        lifetime?.onDrop(() => childElement.remove());
        return childElement;
    }

    public find<T extends Element>(selector: string): Nullable<NodeListOf<T>> {
        const pageFeaturesElement = this.pageFeaturesElement();
        return pageFeaturesElement.querySelectorAll<T>(selector);
    }

    public findFirst<T extends Element>(selector: string): Nullable<T> {
        const pageFeaturesElement = this.pageFeaturesElement();
        return pageFeaturesElement.querySelector<T>(selector);
    }

    public has(selector: string): boolean {
        const pageFeatures = GLOBAL.bodyElement().querySelector("#pagefeatures");
        if (!pageFeatures) {
            return false;
        }
        return pageFeatures.querySelector(selector) !== null;
    }
}